import getKioskCompany from './getKioskCompany.graphql';
import getKioskSurveys from './getKioskSurveys.graphql';
import getEmployeeSurvey from './getEmployeeSurvey.graphql';
import getEmployeeSurveyResult from './getEmployeeSurveyResult.graphql';
import searchPreviewEmployees from './searchPreviewEmployees.graphql';
import submitScaleQuestion from './submitScaleQuestion.graphql';
import submitMultipleQuestion from './submitMultipleQuestion.graphql';
import submitTextQuestion from './submitTextQuestion.graphql';
import submitSurvey from './submitSurvey.graphql';
import languages from './languages.graphql';

const graphql = {
  getKioskCompany,
  getKioskSurveys,
  getEmployeeSurvey,
  getEmployeeSurveyResult,
  searchPreviewEmployees,
  submitScaleQuestion,
  submitMultipleQuestion,
  submitTextQuestion,
  submitSurvey,
  languages,
};

export default graphql;
